import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PaginatedResponse } from "@/types/common";
import { PreConfiguredRegistrationType } from "@/types/pre_configured_registration/registration";
import { useEffect } from "react";
import { useFetcher } from "react-router-dom";
import { PreConfiguredRegistrationTable } from "../registration/pre_configured_registration/table";
import { ActionWrapper } from "@/utils/wretch";

export default function RegistrationDashboard() {
    const fetcherPreConfiguredRegistration = useFetcher<ActionWrapper<PaginatedResponse<PreConfiguredRegistrationType>>>();

    useEffect(() => {
        if (fetcherPreConfiguredRegistration.state === "idle" && !fetcherPreConfiguredRegistration.data) {
            fetcherPreConfiguredRegistration.load("/inscriptions/ventes/api");
        }
    }, []); // Empty dependency array since we only want to load once

    return (
        <Card>
            <CardHeader>
                <CardTitle>Dernières inscriptions pré-configurées</CardTitle>
            </CardHeader>
            <CardContent>
                <PreConfiguredRegistrationTable registrations={fetcherPreConfiguredRegistration.data?.content?.results ?? []} />
            </CardContent>
        </Card>
    );
}
